import { styled } from '@zoopla-eng/zds-components/themes';
import { CmsImage } from '@zoopla/cms/image';

export const Container = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    '@M100': {
        flexDirection: 'row-reverse',
        maxWidth: '100%',
        alignItems: 'flex-start',
    },
});

export const Image = styled(CmsImage, {
    display: 'flex',
    maxWidth: '100%',
    width: '100%',
    borderRadius: '$400',
    height: '51vw',
    objectFit: 'cover',
    '@M100': {
        height: '30vw',
        maxHeight: '337px',
        width: 'auto',
    },
});

export const Content = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: '$S400',
    color: '$purpleDark',
    '@M100': {
        padding: '0 $M100 $S400 0',
        width: '58%',
    },

    '& p': {
        fontGroup: 'ladle',
        marginBottom: '$S500',

        '@M100': {
            fontGroup: 'whisk',
        },
        '&:first-child': {
            marginBottom: '$S500',
        },
    },

    '& h2': {
        marginBottom: '$S200',
    },
});
